<div class="h-full">
  <app-dashboard></app-dashboard>
</div>
